import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    generalSiteSettings : {},
    layoutOptions : [],
    loginPageSettings: {},
    siteAppearanceSettings : {},
    notificationTemplatesSettings : {},
    passwordTemplatesSettings: {},
    advancedSiteSettings: {},
    watermarksSettings: {},
    userLevelsSettings: {},
    registrationFormSettings: {},
    faqs: {},
    faqPdf: '',
    clientConfigurationSettings: {},
    layoutColours: {},
    layoutHeaderImages: {}
};

const getters = {
    getGeneralSiteSettings: (state) => state.generalSiteSettings,
    getLayoutOptions: (state) => state.layoutOptions,
    getLoginPageSettings: (state) => state.loginPageSettings,
    getSiteAppearanceSettings: (state) => state.siteAppearanceSettings,
    getNotificationTemplatesSettings: (state) => state.notificationTemplatesSettings,
    getPasswordTemplatesSettings : (state) => state.passwordTemplatesSettings,
    getAdvancedSiteSettings: (state) => state.advancedSiteSettings,
    getWatermarksSettings: (state) => state.watermarksSettings,
    getUserLevelsSettings: (state) => state.userLevelsSettings,
    getRegistrationFormSettings: (state) => state.registrationFormSettings,
    getFAQs: (state) => state.faqs,
    getFAQPDF: (state) => state.faqPdf,
    getClientConfigurationSettings: (state) => state.clientConfigurationSettings,
    getLayoutColours: (state) => state.layoutColours,
    getLayoutHeaderImages: (state) => state.layoutHeaderImages
};

const actions = {
  // GENERAL SETTINGS TAB
  async getGeneralSiteSettings( context ) {
      await axios.get(`${backendUrl()}/getGeneralSiteSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setGeneralSiteSettings', response.data)
      })
  },
  async setGeneralSiteSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateGeneralSiteSettings`,
      {
          data: data.data,
          userId: context.getters.getUserDetails.id,
          token:context.getters.allTemplateDetails.token
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response)
          context.commit('setNewsnetLogoStatus', response.data.showNewsnetStatus)
          context.commit('setGeneralSiteSettings', response.data)
      })
      .catch(err => {
          context.commit('setValidationErrors', err.response.data.errors)
      })
  },
  // LOGIN PAGE TAB
  async getLoginPageSettings( context ) {
      await axios.get(`${backendUrl()}/getLoginPageSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setLoginPageSettings', response.data)
      })
  },
  async setLoginPageSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateLoginPageSettings`, data,
      {
          headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': "bearer " + vuecookie.get('token')
          }
      })
      .then(response => {
          if(response.data.loginLogoImage){
            context.commit('setLoginLogoImage', response.data.loginLogoImage)
          }
          if(response.data.loginBackgroundImage){
            context.commit('setLoginBackgroundImage', response.data.loginBackgroundImage)
          }
          context.dispatch('handleResponse', response)
          context.commit('setLoginPageSettings', response.data)
      })
  },
  // APPEARANCE TAB
  async getSiteAppearanceSettings( context ) {
      await axios.get(`${backendUrl()}/getSiteAppearanceSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setLayout', response.data.layout)
          context.commit('setLayoutColours', response.data.colours)
          context.commit('setSiteAppearanceSettings', response.data)
      })
  },
  async setSiteAppearanceSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateSiteAppearanceSettings`, data,
      {
          headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': "bearer " + vuecookie.get('token')
          }
      })
      .then(response => {
          context.commit('setLayoutColours', response.data.colours)
          context.commit('setLayout', response.data.layout)
          if(response.data.navbarLogoImage){
            context.commit('setNavbarLogoImage', response.data.navbarLogoImage)
          }
          if(response.data.navbarBackgroundImage){
            context.commit('setNavbarBackgroundImage', response.data.navbarBackgroundImage)
          }
          context.dispatch('handleResponse', response)
          context.commit('setSiteAppearanceSettings', response.data)
      })
      .catch(err => {
        //context.commit('setValidationErrors', err.response.data.errors)
      })
  },
  // NOTIFICATION TEMPLATES TAB
  async getNotificationTemplatesSettings( context ) {
      await axios.get(`${backendUrl()}/getNotificationTemplatesSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setNotificationTemplatesSettings', response.data)
      })
  },
  async setNotificationTemplatesSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateNotificationTemplatesSettings`,
      {
          data: data.data,
          userId: context.getters.getUserDetails.id,
          token:context.getters.allTemplateDetails.token
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response)
          context.commit('setNotificationTemplatesSettings', response.data)
      })
  },
  // PASSWORD TEMPLATES TAB
  async getPasswordTemplatesSettings( context ) {
      await axios.get(`${backendUrl()}/getPasswordTemplatesSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setPasswordTemplatesSettings', response.data)
      })
  },
  async setPasswordTemplatesSettings( context, data ) {
      await axios.post(`${backendUrl()}/updatePasswordTemplatesSettings`,
      {
          data: data.data,
          userId: context.getters.getUserDetails.id,
          token:context.getters.allTemplateDetails.token
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          if(response.data.status == 'success') {
              context.commit('setPasswordHintStatus', response.data.passwordHintStatus)
          }
          context.dispatch('handleResponse', response)
          context.commit('setPasswordTemplatesSettings', response.data)
      })
  },
  // ADVANCED TAB
  async getAdvancedSiteSettings( context ) {
      await axios.get(`${backendUrl()}/getAdvancedSiteSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setAdvancedSiteSettings', response.data)
      })
  },
  async setAdvancedSiteSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateAdvancedSiteSettings`,
      {
          data: data.data,
          userId: context.getters.getUserDetails.id,
          token:context.getters.allTemplateDetails.token
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response)
          context.commit('setAdvancedSiteSettings', response.data)
      })
  },
  // WATERMARKS TAB
  async getWatermarksSettings( context ) {
      await axios.get(`${backendUrl()}/getWatermarksSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setWatermarksSettings', response.data)
      })
  },
  async setWatermarksSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateWatermarksSettings`,
      {
          data: data.data,
          userId: context.getters.getUserDetails.id,
          token:context.getters.allTemplateDetails.token
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response)
          context.commit('setWatermarksSettings', response.data)
      })
  },
  // USER LEVELS TAB
  async getUserLevelsSettings( context ) {
      await axios.get(`${backendUrl()}/getUserLevelsSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setUserLevelsSettings', response.data)
      })
  },
  async setUserLevelsSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateUserLevelsSettings`,
      {
          data: data.data,
          userId: context.getters.getUserDetails.id,
          token:context.getters.allTemplateDetails.token
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response)
          context.commit('setUserLevelsSettings', response.data)
      })
      .catch(err => {
          context.commit('setValidationErrors', err.response.data.errors)
      })
  },
  // REGISTRATION FORM TAB
  async getRegistrationFormSettings( context ) {
      await axios.get(`${backendUrl()}/getRegistrationFormSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setRegistrationFormSettings', response.data)
      })
  },
  async setRegistrationFormSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateRegistrationFormSettings`,
      {
          data: data.data,
          userId: context.getters.getUserDetails.id,
          token:context.getters.allTemplateDetails.token
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          if(response.data.mandatoryRegistrationFields) {
            context.commit('setMandatoryFields', response.data.mandatoryRegistrationFields)
          }
          context.dispatch('handleResponse', response)
          context.commit('setRegistrationFormSettings', response.data)
          //updating registration access status
          let updatedTemplateDetails = context.getters.allTemplateDetails
          updatedTemplateDetails.registrationActivated = response.data.registrationActivatedFormStatus
          context.commit('setTemplateDetails', updatedTemplateDetails)
      })
      .catch(err => {
          context.commit('setValidationErrors', err.response.data.errors)
      })
  },
  // FAQ UPLOAD
  async getFAQs( context, data ) {
      await axios.get(`${backendUrl()}/getFAQs`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') },
          params: {
              userLevel: data.userLevel
          },
      })
      .then(response => {
          context.commit('setFAQs', response.data)
      })
  },
  async uploadFAQ( context, data ) {
      await axios.post(`${backendUrl()}/uploadFAQfile`, data,
      {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': "bearer " + vuecookie.get('token')
        }
      })
      .then(response => {
          console.log(response)
          context.dispatch('handleResponse', response)
          context.dispatch('getFAQs', { userLevel: context.getters.getUserLevel})
      })
  },
  async getFAQData( context, data ) {
    await axios.get(`${backendUrl()}/getFAQData/` + data.id + '/' + data.filename,
    {
        headers: {
            'Content-type': 'application/pdf',
            'Authorization': "bearer " + vuecookie.get('token')
        }
    })
    .then(response => {
        //context.dispatch('handleResponse', response)
        context.commit('setFAQPDF', response.data)
    })
    .catch(err => {
        console.log(err.response)
    })
  },
  async deleteFAQfile( context, data ) {
      await axios.post(`${backendUrl()}/deleteFAQfile`,
      {
          faqId: data.faqId,
          filename: data.filename,
          token:context.getters.allTemplateDetails.token
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response)
      })
  },
  async getClientConfigurationSettings( context, data) {
      await axios.get(`${backendUrl()}/getClientConfigurationSettings`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
        context.commit('setClientConfigurationSettings', response.data)
      })
  },
  async updateClientConfigurationSiteSettings( context, data ) {
      await axios.post(`${backendUrl()}/updateClientConfigurationSettings`,
      {
        data: data.data,
        token:context.getters.allTemplateDetails.token
      },
      {
        headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
        context.dispatch('handleResponse', response)
        context.dispatch('getTemplateDetails', response)
      })
  }
};

const mutations = {
    setGeneralSiteSettings:(state, generalSiteSettings) => (state.generalSiteSettings = generalSiteSettings),
    setLayoutOptions: (state, layoutOptions) => (state.layoutOptions = layoutOptions),
    setLoginPageSettings:(state, loginPageSettings) => (state.loginPageSettings = loginPageSettings),
    setSiteAppearanceSettings:(state, siteAppearanceSettings) => (state.siteAppearanceSettings = siteAppearanceSettings),
    setNotificationTemplatesSettings: (state, notificationTemplatesSettings) => (state.notificationTemplatesSettings = notificationTemplatesSettings),
    setPasswordTemplatesSettings: (state, passwordTemplatesSettings) => (state.passwordTemplatesSettings = passwordTemplatesSettings),
    setAdvancedSiteSettings: (state, advancedSiteSettings) => (state.advancedSiteSettings = advancedSiteSettings),
    setWatermarksSettings: (state, watermarksSettings) => (state.watermarksSettings = watermarksSettings),
    setUserLevelsSettings: (state, userLevelsSettings) => (state.userLevelsSettings = userLevelsSettings),
    setRegistrationFormSettings: (state, registrationFormSettings) => (state.registrationFormSettings = registrationFormSettings),
    setFAQs: (state, faqs) => (state.faqs = faqs),
    setFAQPDF: (state, faqPdf) => (state.faqPdf = faqPdf),
    setClientConfigurationSettings: (state, clientConfigurationSettings) => (state.clientConfigurationSettings = clientConfigurationSettings),
    setLayoutColours: (state, colours) => {
        // the colours stored in the DB do not include a hashtag,
        // but we need it on the UI
        let coloursClone = Object.assign({}, colours)
        if(Object.keys(coloursClone).length){
          for (let [key, value] of Object.entries(coloursClone)) {
              if(!value.includes('#')){
                  coloursClone[key] = '#' + value
              }
          }

        }
        state.layoutColours = coloursClone
        // we also make sure the colours get updated in the local storage
        localStorage.setItem('appearanceColours' , JSON.stringify(coloursClone))
    },
    // letting the UI colour changes to be set individually for the colorpicker in the Site Setup page's Appearance tab
    // we also update the local storage each time a new value is set
    setHeaderBackground: (state, headerBackground) => (
      state.layoutColours.colour_header_bg = headerBackground,
      localStorage.setItem('appearanceColours', JSON.stringify(state.layoutColours))
    ),
    setNavbarColour: (state, navbarColour) => (
      state.layoutColours.colour_nav_bg = navbarColour,
      localStorage.setItem('appearanceColours', JSON.stringify(state.layoutColours))
    ),
    setNavbarTextColour: (state, navbarTextColour) => (
      state.layoutColours.colour_nav_text = navbarTextColour,
      localStorage.setItem('appearanceColours', JSON.stringify(state.layoutColours))
    ),
    setSubmenuTextColour: (state, submenuTextColour) => (
      state.layoutColours.colour_menu_text = submenuTextColour,
      localStorage.setItem('appearanceColours', JSON.stringify(state.layoutColours))
    ),
    setSubmenuColour: (state, subMenuColour) => (
      state.layoutColours.colour_menu_inner = subMenuColour,
      localStorage.setItem('appearanceColours', JSON.stringify(state.layoutColours))
    ),
    //setLayoutHeaderImages: (state, layoutHeaderImages) => (state.layoutHeaderImages = layoutHeaderImages)
};

export default {
  state,
  getters,
  actions,
  mutations
}
